<ng-container
    *ngrxLet="{
        isGeoZonesInfoEnabled: isGeoZonesInfoEnabled$,
        isMeasureToolActive: isMeasureToolActive$,
        isGeoZonesInfoAvailable: isGeoZonesInfoAvailable$,
        isGeoZonesInfoButtonVisible: isGeoZonesInfoButtonVisible$,
        isMeasureToolVisible: isMeasureToolVisible$,
        isMeasureToolEnabled: isMeasureToolEnabled$,
        isDefaultView: isDefaultView$,
        canGetGeolocation: canGetGeolocation$
    } as vm"
>
    <div class="control-buttons" *ngIf="vm.isGeoZonesInfoAvailable && vm.isGeoZonesInfoButtonVisible">
        <button
            type="button"
            (click)="toggleGeoZoneInfo()"
            [class.active]="vm.isGeoZonesInfoEnabled"
            [matTooltip]="'dtmMapCesium.zoneInfoToggleButtonTooltip' | transloco"
            [attr.aria-label]="'dtmMapCesium.zoneInfoToggleButtonTooltip' | transloco"
            role="switch"
            [attr.aria-checked]="vm.isGeoZonesInfoEnabled"
            matTooltipPosition="left"
        >
            <dtm-ui-icon name="cylinder-question" />
        </button>
    </div>
    <div class="control-buttons" *ngIf="vm.isMeasureToolVisible">
        <button
            type="button"
            [class.active]="vm.isMeasureToolActive"
            (click)="toggleMeasure()"
            [disabled]="!vm.isMeasureToolEnabled"
            [attr.aria-label]="'dtmMapCesium.measureToolButtonAriaLabel' | transloco"
            [attr.aria-checked]="vm.isMeasureToolActive"
        >
            <dtm-ui-icon name="ruler" />
        </button>
    </div>
    <div class="control-buttons">
        <button
            type="button"
            (click)="setDefaultCamera()"
            [disabled]="vm.isDefaultView"
            [attr.aria-label]="'dtmMapCesium.resetViewButtonAriaLabel' | transloco"
        >
            <dtm-ui-icon name="north" />
        </button>
    </div>
    <div class="control-buttons">
        <button
            type="button"
            (click)="geolocate()"
            *ngIf="geolocationService"
            [disabled]="!vm.canGetGeolocation"
            [attr.aria-label]="'dtmMapCesium.locationButtonAriaLabel' | transloco"
        >
            <dtm-ui-icon name="focus-2" />
        </button>
    </div>
    <div class="control-buttons">
        <button type="button" (click)="zoomIn()" [attr.aria-label]="'dtmMapCesium.zoomInButtonAriaLabel' | transloco">
            <dtm-ui-icon name="add" />
        </button>
        <button type="button" (click)="zoomOut()" [attr.aria-label]="'dtmMapCesium.zoomOutButtonAriaLabel' | transloco">
            <dtm-ui-icon name="subtract" />
        </button>
    </div>
</ng-container>
